/*!
* jQuery UI Timepicker 0.2.1
*
* Copyright (c) 2009 Martin Milesich (http://milesich.com/)
* Copyright (c) 2009 AUTHORS.txt (http://jqueryui.com/about)
*
* $Id: timepicker.js 29 2009-08-15 20:38:20Z majlo $
*
* Depends:
*  ui.core.js
*  ui.datepicker.js
*  ui.slider.js
*/
(function ($) {

	/**
	* Extending default values
	*/
	$.extend($.datepicker._defaults, {
		'stepMinutes': 1, // Number of minutes to step up/down
		'stepHours': 1, // Number of hours to step up/down
		'time24h': true, // True if 24h time
		'showTime': false, // Show timepicker with datepicker
		'altTimeField': '' // Selector for an alternate field to store time into
	});
	var PROP_NAME = 'timepicker';
	$.datepicker.parseDateOverride = $.datepicker.parseDate;
	$.datepicker.parseDate = function (format, value, settings) {
		// Just parse the time, then modify the format.

		if ((settings != undefined && settings.showTime != undefined && settings.showTime) || format.indexOf('HH:II') > 0) {
			var time = value.substr(value.length - 5, 5);
			var newFormat = format;
			if (time != "")
				newFormat = format.replace("HH:II", time);
			var date = $.datepicker.parseDateOverride.call(this, newFormat, value, settings);
			if (time != "") {
				var hours = time.substr(0, 2);
				var minutes = time.substr(3, 2);
				date.setHours(hours);
				date.setMinutes(minutes);
			}
			return date;
		}
		return $.datepicker.parseDateOverride.apply(this, arguments);

	};
	$.datepicker._addTime = function (inst, date) {
		if (date == null)
			return null;
		date.setHours(inst.currentHours);
		date.setMinutes(inst.currentMinutes);
		return date;
	};
	$.datepicker._getDateOverride = $.datepicker._getDate;
	$.datepicker._getDate = function (inst) {
		var startDate = (!inst.currentYear || (inst.input && inst.input.val() == '') ? null :
			new Date(
			inst.currentYear, inst.currentMonth, inst.currentDay));
		if ($.datepicker._get(inst, 'showTime'))
			return this._addTime(inst, startDate);
		return startDate;
	};
	$.datepicker.formatDateOverride = $.datepicker.formatDate;
	$.datepicker.formatDate = function (format, date, settings) {
		var formattedDate = $.datepicker.formatDateOverride.apply(this, arguments);
		// Now replace HH:II with time
		var hours = "0";
		var mins = "0";
		if (date != null) {
			hours = date.getHours().toString();
			mins = date.getMinutes().toString();
		}
		if (mins.length == 1)
			mins = "0" + mins
		if (hours.length == 1)
			hours = "0" + hours
		formattedDate = formattedDate.replace('HH', hours);
		formattedDate = formattedDate.replace('II', mins);
		return formattedDate;
	};
	$.datepicker._formatDateOverride = $.datepicker._formatDate;
	$.datepicker._formatDate = function (inst, day, month, year) {
		if (!day) {

			inst.currentDay = inst.selectedDay;
			inst.currentMonth = inst.selectedMonth;
			inst.currentYear = inst.selectedYear;
			inst.currentMinutes = inst.selectedMinutes;
			inst.currentHours = inst.selectedHours;
		}
	    if (inst.currentHours == undefined)
	        inst.currentHours = 0;
	    if (inst.currentMinutes == undefined)
	        inst.currentMinutes = 0;
		var date = (day ? (typeof day == 'object' ? day :
			new Date(year, month, day)) :
			new Date(inst.currentYear, inst.currentMonth, inst.currentDay));
		// We have the date now
		// Add time
		if ($.datepicker._get(inst, 'showTime')) {
			date.setHours(inst.currentHours);
			date.setMinutes(inst.currentMinutes);

			return $.datepicker.formatTime($.datepicker._formatDateOverride.call(this, inst, day, month, year), inst);
		}
		return $.datepicker._formatDateOverride.call(this, inst, day, month, year);
	};
	
	$.datepicker._setDateOverride = $.datepicker._setDate;
	$.datepicker._setDate = function (inst, date, nochange) {
		// Datepicker show on set fix
		$(inst.dpDiv).hide();
		if ($.datepicker._get(inst, 'showTime')) {
			inst.drawHours = inst.selectedHours = inst.currentHours = date.getHours();
			inst.drawMinutes = inst.selectedMinutes = inst.currentMinutes = date.getMinutes();
		}
		//	var enableFix = !$(inst.input).is(':disabled');

		//	if (enableFix)
		//	$(inst.input).datepicker('disable');
		return $.datepicker._setDateOverride.apply(this, arguments);
		//if (enableFix)
		//$(inst.input).datepicker("enable");
	};
	$.datepicker._determineDateOverride = $.datepicker._determineDate;
	$.datepicker._determineDate = function (inst, date, defaultDate) {
		var checkHours = false;

		if (date != null)
			checkHours = true;
		if (checkHours && $.datepicker._get(inst, 'showTime')) {
			var hours = inst.drawHours = inst.selectedHours = inst.currentHours = date.getHours();
			var minutes = inst.drawMinutes = inst.selectedMinutes = inst.currentMinutes = date.getMinutes();


		}
		var d = $.datepicker._determineDateOverride.apply(this, arguments);

		if (checkHours && $.datepicker._get(inst, 'showTime')) {
			date.setHours(hours);
			date.setMinutes(minutes);
		}

		return d;

	};

	$.datepicker.formatTime = function (dateStr, inst) {

		if ($.datepicker._get(inst, 'showTime') && inst.settings.dateFormat.indexOf('HH:II') >= 0) {
			var timeStr = "";
			if (inst.currentHours == undefined)
				timeStr += "00:"
			else
				timeStr += inst.currentHours + ":";
			if (inst.currentMinutes == undefined)
				timeStr += "00"
			else
				timeStr += inst.currentMinutes;


			if (timeStr.indexOf(':') == 1)
				timeStr = "0" + timeStr;
			if (timeStr.length < 5)
				timeStr = timeStr.substr(0, 3) + "0" + timeStr.substr(3, 1);

			return dateStr.substr(0, dateStr.length - 5) + timeStr;
		}
		return dateStr;
	};
	/**
	* _hideDatepicker must be called with null
	*/
	$.datepicker._connectDatepickerOverride = $.datepicker._connectDatepicker;
	$.datepicker._connectDatepicker = function (target, inst) {
		$.datepicker._connectDatepickerOverride(target, inst);

		// showButtonPanel is required with timepicker
		// MZ: No it's not
		//if (this._get(inst, 'showTime')) {
		//	inst.settings['showButtonPanel'] = true;
		//}

		var showOn = this._get(inst, 'showOn');

		//if (showOn == 'button' || showOn == 'both') {
		// Unbind all click events


		// Bind new click event

		//}
	};

	/**
	* Datepicker does not have an onShow event so I need to create it.
	* What I actually doing here is copying original _showDatepicker
	* method to _showDatepickerOverload method.
	*/

	$.datepicker._showDatepickerOverride = $.datepicker._showDatepicker;
	$.datepicker._showDatepicker = function (input) {

		$.timepicker.hidden = false;
		// Call the original method which will show the datepicker
		$.datepicker._showDatepickerOverride(input);

		$('.ui-datepicker-calendar').find('a').each(function () { $(this).attr('href', 'javascript:void(0);'); });
		input = input.target || input;

		// find from button/image trigger
		if (input.nodeName.toLowerCase() != 'input') input = $('input', input.parentNode)[0];

		// Do not show timepicker if datepicker is disabled
		if ($.datepicker._isDisabledDatepicker(input)) return;

		// Get instance to datepicker
		var inst = $.datepicker._getInst(input);

		var slf = this;
		$('#' + $.datepicker._mainDivId).unbind('updateTime');
	    (function(inst) {

	        $('#' + $.datepicker._mainDivId).bind('updateTime', function() {

			var showTime = $.datepicker._get(inst, 'showTime');
			var dateStr = null;
			dateStr = (dateStr != null ? dateStr : $.datepicker._formatDate(inst));
			if (showTime) {
				//if (inst.input)
				//	inst.input.val(dateStr);
				$.datepicker._updateAlternate(inst);

				$.timepicker.update($.datepicker._formatDate(inst));
			}
		});
	    })(inst);
		var showTime = $.datepicker._get(inst, 'showTime');

		// If showTime = True show the timepicker
		if (showTime) {
		    (function(input) {
		        window.setTimeout(function() {
				if ($('#' + $.datepicker._mainDivId).filter(':animated').length == 0)
		                $.timepicker.show(input,inst);
				else
					window.setTimeout(arguments.callee, 10);
			}, 10);
		    })(input);

		}
	};

	/**
	* Same as above. Here I needed to extend the _checkExternalClick method
	* because I don't want to close the datepicker when the sliders get focus.
	*/
	$.datepicker._checkExternalClickOverride = $.datepicker._checkExternalClick;
	$.datepicker._checkExternalClick = function (event) {
		if (!$.datepicker._curInst) return;
		var $target = $(event.target);

		if (($target.parents('#' + $.timepicker._mainDivId).length == 0)) {
			$.datepicker._checkExternalClickOverride(event);
		}
	};

	/**
	* Datepicker has onHide event but I just want to make it simple for you
	* so I hide the timepicker when datepicker hides.
	*/
	$.datepicker._hideDatepickerOverride = $.datepicker._hideDatepicker;
	$.datepicker._hideDatepicker = function (input, duration) {
		// Some lines from the original method
		var inst = this._curInst;

		if (!inst || (input && inst != $.data(input, 'timepicker'))) return;

		// Get the value of showTime property
		var showTime = this._get(inst, 'showTime');

		if (input === undefined && $.datepicker._get(inst, 'showTime')) {
			if (inst.input) {
				inst.input.val(this._formatDate(inst));
				inst.input.trigger('change'); // fire the change event
			}

			this._updateAlternate(inst);


		}
		if ($.datepicker._get(inst, 'showTime'))
			$.timepicker.update(this._formatDate(inst));
		// Hide datepicker
		$.datepicker._hideDatepickerOverride(input, duration);

		// Hide the timepicker if enabled
		if (showTime) {
			$.timepicker.hidden = true;
			$.timepicker.hide();
		}
	};

	/**
	* This is a complete replacement of the _selectDate method.
	* If showed with timepicker do not close when date is selected.
	*/
	$.datepicker._selectDateOverride = $.datepicker._selectDate;
	$.datepicker._selectDate = function (id, dateStr) {

		var target = $(id);
		var inst = this._getInst(target[0]);
		var showTime = this._get(inst, 'showTime');
		dateStr = (dateStr != null ? dateStr : this._formatDate(inst));
		if (!showTime) {
			return $.datepicker._selectDateOverride.call(this, id, dateStr);
		}
		if (showTime) {
			if (inst.input)
				inst.input.val(dateStr);
			this._updateAlternate(inst);
		}
		var onSelect = this._get(inst, 'onSelect');
		if (onSelect)
			onSelect.apply((inst.input ? inst.input[0] : null), [dateStr, inst]);  // trigger custom callback
		else if (inst.input && !showTime)
			inst.input.trigger('change'); // fire the change event
		if (inst.inline)
			this._updateDatepicker(inst);
		else if (!inst.stayOpen) {
			//			if (showTime) {
			this._updateDatepicker(inst);
			//			} else {
			if (!showTime)
				this._hideDatepicker(null, this._get(inst, 'duration'));
			this._lastInput = inst.input[0];
			inst.input.blur();
			//	if (typeof (inst.input[0]) != 'object')
			//inst.input[0].focus(); // restore focus
			this._lastInput = null;
			//			}
		}
	};

	/**
	* We need to resize the timepicker when the datepicker has been changed.
	*/
	$.datepicker._updateDatepickerOverride = $.datepicker._updateDatepicker;
	$.datepicker._updateDatepicker = function (inst) {
		$.datepicker._updateDatepickerOverride(inst);
		$.timepicker.resize();

	};

	function Timepicker() { }

	Timepicker.prototype = {
		init: function () {
			this._mainDivId = 'ui-timepicker-div';
			this._inputId = null;
			this._orgValue = null;
			this._orgHour = null;
			this._orgMinute = null;
			this._colonPos = -1;
			this._visible = false;
			this.tpDiv = $('<div id="' + this._mainDivId + '" class="ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all ui-helper-hidden-accessible" style="width: 72px; display: none; position: absolute;"></div>');
			this._generateHtml();
		},

		show: function (input, inst) {
			// Get instance to datepicker
            if (inst == undefined)
			 inst = $.datepicker._getInst(input);

			if ($.timepicker.hidden != undefined && $.timepicker.hidden == true)
				return;
			this._time24h = $.datepicker._get(inst, 'time24h');
			this._altTimeField = $.datepicker._get(inst, 'altTimeField');
			var stepMinutes = parseInt($.datepicker._get(inst, 'stepMinutes'), 10) || 1;
			var stepHours = parseInt($.datepicker._get(inst, 'stepHours'), 10) || 1;

			if (60 % stepMinutes != 0) { stepMinutes = 1; }
			if (24 % stepHours != 0) { stepHours = 1; }

			$('#hourSlider').slider('option', 'max', 24 - stepHours);
			$('#hourSlider').slider('option', 'step', stepHours);

			$('#minuteSlider').slider('option', 'max', 60 - stepMinutes);
			$('#minuteSlider').slider('option', 'step', stepMinutes);
			this._inputId = input.id;

			if (!this._visible) {
				this._parseTime();
				this._orgValue = $(document.getElementById(this._inputId)).val();
			}

			this.resize();
			$('#' + this._mainDivId).fadeIn();
			this._visible = true;
			var dpDiv = $('#' + $.datepicker._mainDivId);
			var dpDivPos = dpDiv.position();
			var viewWidth = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) + $(document).scrollLeft();
			var tpRight = this.tpDiv.offset().left + this.tpDiv.outerWidth();
			if (tpRight > viewWidth) {
				dpDiv.css('left', dpDivPos.left - (tpRight - viewWidth) - 5);
				this.tpDiv.css('left', dpDiv.offset().left + dpDiv.outerWidth() + 'px');
			}
		},
		fdSet: '',
		update: function (fd) {
			fdSet = fd;

			var curTime = $('#' + this._mainDivId + ' span.fragHours').text()
                    + ':'
                    + $('#' + this._mainDivId + ' span.fragMinutes').text();

			if (!this._time24h) {
				curTime += ' ' + $('#' + this._mainDivId + ' span.fragAmpm').text();
			}
			var input = document.getElementById(this._inputId);

			var curDate = $(document.getElementById(this._inputId)).val();
			var inst = $.datepicker._getInst(input);
			inst.drawHours = inst.selectedHours = inst.currentHours = $('#' + this._mainDivId + ' span.fragHours').text();
			inst.drawMinutes = inst.selectedMinutes = inst.currentMinutes = $('#' + this._mainDivId + ' span.fragMinutes').text();


			$(document.getElementById(this._inputId)).val(fd.substr(0, fd.length - 5) + curTime);

			if (this._altTimeField) {
				$(this._altTimeField).each(function () { $(this).val(curTime); });
			}
		},

		hide: function () {
			this._visible = false;
			$('#' + this._mainDivId).hide();
		},

		resize: function () {
			var dpDiv = $('#' + $.datepicker._mainDivId);
			var dpDivPos = dpDiv.position();
			var hdrHeight = $('#' + $.datepicker._mainDivId + ' > div.ui-datepicker-header:first-child').height();

			$('#' + this._mainDivId + ' > div.ui-datepicker-header:first-child').css('height', hdrHeight);
			this.tpDiv.css({
				'height': dpDiv.height(),
				'top': dpDivPos.top,
				'left': dpDivPos.left + dpDiv.outerWidth() + 'px'
			});
			var sliderHeight = $('#' + $.datepicker._mainDivId + ' table.ui-datepicker-calendar').outerHeight();
			var trHeight = $('#' + $.datepicker._mainDivId + ' table.ui-datepicker-calendar tr:first').outerHeight();
			$('#hourSlider').css('margin', '5px 11px');

			$('#minuteSlider').css('margin', '5px 11px');
			$('#hourSlider').setOuterHeight(sliderHeight - trHeight - 11);
			$('#minuteSlider').setOuterHeight(sliderHeight - trHeight - 11);
		},

		_generateHtml: function () {
			var html = '';

			html += '<div class="ui-datepicker-header ui-widget-header ui-helper-clearfix ui-corner-all">';
			html += '<div class="ui-datepicker-title" style="margin:0">';
			html += '<span class="fragHours">08</span><span class="delim">:</span><span class="fragMinutes">45</span> <span class="fragAmpm"></span></div></div><table style="background:white">';
			html += '<tr><th>Hour</th><th>Min</th></tr>';
			html += '<tr><td align="center"><div id="hourSlider" class="slider"></div></td><td align="center"><div id="minuteSlider" class="slider"></div></td></tr>';
			html += '</table>';

			this.tpDiv.empty().append(html);
			$('body').append(this.tpDiv);

			var self = this;

			$('#hourSlider').slider({
				orientation: "vertical",
				range: 'min',
				min: 0,
				max: 23,
				step: 1,
				slide: function (event, ui) {
					self._writeTime('hour', ui.value);
					$('#' + $.datepicker._mainDivId).trigger('updateTime');
				},
				stop: function (event, ui) {
					$(document.getElementById(self._inputId)).focus();

				}
			});

			$('#minuteSlider').slider({
				orientation: "vertical",
				range: 'min',
				min: 0,
				max: 59,
				step: 1,
				slide: function (event, ui) {
					self._writeTime('minute', ui.value);

					$('#' + $.datepicker._mainDivId).trigger('updateTime');
				},
				stop: function (event, ui) {
					$(document.getElementById(self._inputId)).focus();
				}
			});

			$('#hourSlider > a').css('padding', 0);
			$('#minuteSlider > a').css('padding', 0);
		},

		_writeTime: function (type, value) {
			if (type == 'hour') {
				if (!this._time24h) {
					if (value < 12) {
						$('#' + this._mainDivId + ' span.fragAmpm').text('am');
					} else {
						$('#' + this._mainDivId + ' span.fragAmpm').text('pm');
						value -= 12;
					}

					if (value == 0) value = 12;
				} else {
					$('#' + this._mainDivId + ' span.fragAmpm').text('');
				}

				if (value < 10) value = '0' + value;
				$('#' + this._mainDivId + ' span.fragHours').text(value);
			}

			if (type == 'minute') {
				if (value < 10) value = '0' + value;
				$('#' + this._mainDivId + ' span.fragMinutes').text(value);
			}
		},

		_parseTime: function () {
			var dt = $(document.getElementById(this._inputId)).val();
			this._colonPos = dt.search(':');
			var m = 0, h = 0, a = '';
			if (this._colonPos != -1) {
				var fDt = dt.substr(0, this._colonPos - 2);
				h = parseInt(dt.substr(this._colonPos - 2, 2), 10);
				m = parseInt(dt.substr(this._colonPos + 1, 2), 10);
				a = jQuery.trim(dt.substr(this._colonPos + 3, 3));

			}
			a = a.toLowerCase();
			if (a != 'am' && a != 'pm') {
				a = '';
			}
			if (h < 0) h = 0;
			if (m < 0) m = 0;
			if (h > 23) h = 23;
			if (m > 59) m = 59;
			if (a == 'pm' && h < 12) h += 12;
			if (a == 'am' && h == 12) h = 0;
			this._setTime('hour', h);
			this._setTime('minute', m);
			this._orgHour = h;
			this._orgMinute = m;
		},

		_setTime: function (type, value) {
			if (isNaN(value)) value = 0;
			if (value < 0) value = 0;
			if (value > 23 && type == 'hour') value = 23;
			if (value > 59 && type == 'minute') value = 59;

			if (type == 'hour') {
				$('#hourSlider').slider('value', value);
			}

			if (type == 'minute') {
				$('#minuteSlider').slider('value', value);
			}

			this._writeTime(type, value);
		}
	};

	$.timepicker = new Timepicker();
	$('document').ready(function () { $.timepicker.init(); });

})(jQuery);

